/*
 * "Property" / "Property People" set to echo the logo: heavy geometric
 * capitals, PROPERTY in the text colour and PEOPLE in the logo's light blue,
 * with the logo's map pin standing in for the O of PROPERTY.
 *
 * The logo itself is outlined paths, not a font. Poppins 800 is the closest
 * Google font in weight and letter width. It is loaded in public/index.html
 * with &text= limited to the capitals used by these words and the hero's
 * LETTINGS · SALES · MANAGEMENT links, so any other letter set in this style
 * would fall back to Roboto - extend that list if you add one.
 *
 * Real text rather than the logo SVG, so it stays part of the heading for
 * search engines and screen readers. The pin is aria-hidden and a visually
 * hidden "o" takes its place, so the word still reads, copies and indexes as
 * "Property".
 */

import styled, { css } from "styled-components";

/* Shared with the hero's service links (HeroBanner.js), which match PEOPLE. */
export const brandLettering = css`
    font-family: "Poppins", "Roboto", sans-serif;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.01em;
`;

export const brandBlue = "#b4e1fa";

const Brand = styled.span`
    ${brandLettering}
    /* Keep "Property People" on one line rather than splitting the name. */
    white-space: nowrap;
`;

const People = styled.span`
    color: ${brandBlue};
`;

/*
 * Sized from the logo: the pin is 1.28x the logo's cap height and overhangs
 * it equally top and bottom. Poppins caps are ~0.7em, so 0.9em tall sitting
 * 0.1em below the baseline.
 */
const Pin = styled.svg`
    display: inline-block;
    height: 0.9em;
    width: 0.625em;
    vertical-align: -0.1em;
    margin: 0 0.02em 0 0.04em;
`;

const VisuallyHidden = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
`;

/* The three pin shapes from pp-logo-light.svg, in the logo's own coordinates. */
function PinO() {
    return (
        <>
            <Pin viewBox="61.77 6 30.26 43.57" aria-hidden="true" focusable="false">
                <path
                    fill="currentColor"
                    d="M76.9,6A15.11,15.11,0,0,0,61.77,21.1c0,.57,0,1.15.08,1.73a32.3,32.3,0,0,0,2.44,9.06c.49,1.22,1,2.43,1.64,3.62h0a13.64,13.64,0,0,1,21.93,0h0c.58-1.19,1.14-2.4,1.64-3.62a32.52,32.52,0,0,0,2.43-9.06c0-.58.08-1.16.08-1.73A15.11,15.11,0,0,0,76.9,6Z"
                />
                <path fill="#b4e1fa" d="M76.9,15.62a6.15,6.15,0,1,0,4.34,1.8A6.12,6.12,0,0,0,76.9,15.62Z" />
                <path
                    fill="#b4e1fa"
                    d="M87.86,35.51a13.64,13.64,0,0,0-21.93,0,0,0,0,0,0,0,0,88.87,88.87,0,0,0,7.48,12.24h0a4.28,4.28,0,0,0,7,0h0a89.89,89.89,0,0,0,7.47-12.24Z"
                />
            </Pin>
            <VisuallyHidden>o</VisuallyHidden>
        </>
    );
}

export default function BrandName({ people }) {
    return (
        <Brand>
            Pr
            <PinO />
            perty
            {people && <People> People</People>}
        </Brand>
    );
}
